import React, { useState, useEffect } from "react";
import Sidebar from "../reusables/Sidebar";
import agent from "../../agent";
import useCart from "../../Utils/hooks/useCart";
import Alert from "../../Utils/Alert";

const SearchSidebar = ({ isOpen, onClose }) => {
  const [searchText, setSearchText] = useState("");
  const [allProducts, setAllProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);

  const { getCartQuantity } = useCart();

  // Fetching all products
  useEffect(() => {
    if (!isOpen) return;
    if (isOpen) setSearchText("");

    const payload = { status: ["IN-STOCK", "LOW-STOCK"] };
    agent.Product.get(payload)
      .then((res) => {
        if (res?.status === 200 && res?.data?.data) {
          setAllProducts(res.data.data);
          setFilteredProducts(res.data.data);
        } else {
          Alert.showToastAlert("error", res?.message);
        }
      })
      .catch((err) => {
        Alert.showToastAlert("error", err.message);
      });
  }, [isOpen]);

  // Filter when search changes
  useEffect(() => {
    const value = searchText.trim().toLowerCase();
    if (value) {
      setFilteredProducts(
        allProducts.filter(
          (p) =>
            p.name.toLowerCase().includes(value) ||
            p.description?.toLowerCase().includes(value) ||
            p.category?.name?.toLowerCase().includes(value)
        )
      );
    } else {
      setFilteredProducts(allProducts);
    }
  }, [searchText, allProducts]);

  // handle main scrollbar scroll
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const renderProducts = (items) => (
    <div className="products_container">
      {items.map((valu, i) => (
        <div className="product_wrp" key={i}>
          <div className="product_img">
            <img src={valu.images[0]?.path} alt={valu.name} />
            {valu.discount > 0 && (
              <div className="on_sale">{valu.discount}% off</div>
            )}
          </div>
          <div className="product_info">
            <h5>{valu.name}</h5>
            <span>
              Qty:&nbsp; {valu.qty}/{valu.unit?.name}
            </span>
            <div className="d-flex justify-content-between align-items-center">
              <div className="price">
                <span
                  className={`product_price ${
                    valu.discount > 0 && "cut_price"
                  }`}
                >
                  ₹{valu.price}
                </span>
                {valu.discount > 0 && (
                  <span className="product_price">₹{valu.finalPrice}</span>
                )}
              </div>
              {getCartQuantity(valu._id, valu.status)}
            </div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <Sidebar onClose={onClose} isOpen={isOpen}>
      <h3>Search Products</h3>
      <input
        type="text"
        className="form-control my-2"
        placeholder="Search by product name..."
        value={searchText}
        onChange={(e) => setSearchText(e.target.value)}
      />

      <div
        className="search_results"
        style={{ height: "calc(100% - 120px)", overflowY: "auto" }}
      >
        {filteredProducts.length > 0 ? (
          renderProducts(filteredProducts)
        ) : (
          <p className="no_result">No products found.</p>
        )}
      </div>
    </Sidebar>
  );
};

export default SearchSidebar;
